import { Component } from 'opus-angular-seed-core';
import template from './template.html';

@Component({
    bindings: {
        ngModel: '=',
        ngChange: '&',
        ngDisabled: '=',
        class: '@'
    },
    template
})
export default class {
    constructor () {
        this.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 1,
            showButtonBar: false,
            appendToBody: true,
            showWeeks: false,
            maxMode: 'year'
        };
        this.format = 'dd.MM.yyyy';
        this.opened = false;
    }

    open () {
        this.opened = true;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/datepicker/index.js